import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ExpertsList } from './components/ExpertsList';
import { ExpertDossiers } from './components/ExpertDossiers';
import type { Expert } from './types/expert.types';

export const ExpertTab: React.FC = () => {
  const location = useLocation();
  
  // Check if we're returning from expertise detail with expert context
  const navigationState = location.state as { selectedExpert?: Expert; viewMode?: 'list' | 'dossiers' } | null;
  
  const [viewMode, setViewMode] = useState<'list' | 'dossiers'>(
    navigationState?.viewMode || 'list'
  );
  const [selectedExpert, setSelectedExpert] = useState<Expert | null>(
    navigationState?.selectedExpert || null
  );

  // Clear navigation state after using it to prevent stale state
  useEffect(() => {
    if (navigationState) {
      window.history.replaceState({}, document.title);
    }
  }, []);

  const handleExpertSelect = (expert: Expert) => {
    setSelectedExpert(expert);
    setViewMode('dossiers');
  };

  const handleBackToList = () => {
    setViewMode('list');
    setSelectedExpert(null);
  };

  return (
    <>
      {viewMode === 'list' ? (
        <ExpertsList onExpertSelect={handleExpertSelect} />
      ) : (
        selectedExpert && (
          <ExpertDossiers 
            expert={selectedExpert}
            onBack={handleBackToList}
          />
        )
      )}
    </>
  );
};